import { ClientOnly } from 'remix-utils/client-only'
import { World } from '#app/components/globe.client.js'
import { sampleArcs, globeConfig } from './globe'

export default function AboutRoute() {
	return (
		<div>
			<div className="top-0 h-screen w-full flex-row items-center justify-center bg-red md:h-auto">
				<div className="relative top-0 mx-auto h-full w-full overflow-hidden md:h-[40rem]">
					<div></div>

					<div className="pointer-events-none absolute inset-x-0 bottom-0 z-40 h-40 select-none bg-gradient-to-b from-transparent to-red dark:to-red" />
					<div className="h-100 absolute -bottom-20 z-10 w-full md:h-full">
						<ClientOnly fallback={<></>}>
							{() => (
								<World
									data={sampleArcs.map((arc) => ({
										...arc,
										color: arc.color || '',
									}))}
									globeConfig={globeConfig}
								/>
							)}
						</ClientOnly>
					</div>
				</div>
			</div>
		</div>
	)
}
